var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 140,
    viewBox: "0 0 175 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5231 10.2045C80.5231 10.2045 78.8687 -1.32067 72.6599 0.125552C66.4512 1.57178 65.8898 13.4055 69.8567 11.5541C73.8236 9.7026 63.0048 1.20743 60.8113 7.46448C58.6178 13.7215 66.0609 18.3576 63.6852 14.1565C61.3095 9.95541 42.754 16.4467 49.6505 16.9709C56.547 17.4951 98.6548 16.8036 95.0076 15.5247C91.3605 14.2457 81.8801 14.361 81.8801 14.361C81.8801 14.361 89.0257 9.61709 84.4416 6.58708C79.8576 3.55708 76.3629 13.8851 78.4448 12.0448L80.5231 10.2045Z",
    fill: "#F7E7DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4837 17.9814C82.4837 17.9814 85.3612 21.8182 83.8295 21.3684C82.2978 20.9185 82.4837 17.9814 82.4837 17.9814Z",
    fill: "#707FE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0813 16.2686C79.0813 16.2686 81.9589 20.109 80.4272 19.6555C78.8954 19.2019 79.0813 16.2686 79.0813 16.2686Z",
    fill: "#707FE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8008 21.2236C77.8008 21.2236 81.5483 27.2167 80.0315 26.7669C78.5146 26.317 77.8008 21.2236 77.8008 21.2236Z",
    fill: "#707FE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1523 16.7295C69.1523 16.7295 72.9036 22.7263 71.383 22.2764C69.8624 21.8266 69.1523 16.7295 69.1523 16.7295Z",
    fill: "#707FE0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8329 16.4873C63.8329 16.4873 66.7068 20.3241 65.1788 19.8742C63.6508 19.4244 63.8329 16.4873 63.8329 16.4873Z",
    fill: "#707FE0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1809 22.0488C65.1809 22.0488 68.0585 25.8893 66.5268 25.4357C64.995 24.9822 65.1809 22.0488 65.1809 22.0488Z",
    fill: "#707FE0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5637 13.7178C69.5637 13.7178 72.4413 17.5583 70.9096 17.1084C69.3778 16.6586 69.5637 13.7178 69.5637 13.7178Z",
    fill: "#707FE0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7317 17.7969C60.7317 17.7969 63.6093 21.6374 62.0887 21.1912C60.5681 20.7451 60.7317 17.7969 60.7317 17.7969Z",
    fill: "#707FE0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.85 65.9013C139.85 65.9013 144.832 60.3729 142.184 56.4209C139.537 52.4689 137.422 45.7285 137.422 45.7285C137.422 45.7285 129.176 55.8781 139.85 65.9013Z",
    fill: "#D5CD45"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.338 78.5559C134.338 78.5559 142.391 65.116 139.294 57.3867",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.689 51.7807C136.17 51.3088 137.589 50.6623 138.917 49.8549C138.288 48.286 137.824 46.9439 137.593 46.2412L136.615 46.9178C135.713 48.4231 135.062 50.0657 134.689 51.7807Z",
    fill: "#191919"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.039 67.5146C147.039 67.5146 151.601 59.3354 157.393 60.8783C163.185 62.4212 172.082 62.2056 172.082 62.2056C172.082 62.2056 163.33 76.1659 147.039 67.5146Z",
    fill: "#D5CD45"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.474 56.5102C150.474 56.5102 144.068 46.0594 148.202 41.7208C152.337 37.3821 156.593 24.5371 156.593 24.5371C156.593 24.5371 171.532 46.2565 150.474 56.5102Z",
    fill: "#D5CD45"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.213 79.2333C134.213 79.2333 146.957 64.1688 157.434 64.7116",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.686 71.1204C142.686 71.1204 148.712 66.6182 150.474 56.5095C151.594 50.4916 153.359 44.612 155.739 38.9727",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.62 51.48C129.62 51.48 127.832 42.2822 133.256 39.7318C138.681 37.1814 145.339 31.2812 145.339 31.2812C145.339 31.2812 147.648 47.5875 129.62 51.48Z",
    fill: "#D5CD45"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M125.152 40.8543C125.152 40.8543 113.519 36.9915 113.88 31.0096C114.24 25.0277 109.232 12.4727 109.232 12.4727C109.232 12.4727 134.644 19.4398 125.152 40.8543Z",
    fill: "#D5CD45"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M127.35 68.7196C127.35 68.7196 127.383 48.9855 135.744 42.6504",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.613 57.0415C128.613 57.0415 130.304 49.7249 125.152 40.8542C122.122 35.5311 119.676 29.8972 117.854 24.0498",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6016 28.0872C31.6016 28.0872 32.6835 22.1982 26.0249 24.0237C19.3663 25.8491 23.5228 19.8523 29.1033 21.4547C34.6837 23.057 31.7057 26.9087 30.8283 22.8972C29.9509 18.8857 26.1476 16.8335 27.1403 15.0898C28.1329 13.3462 30.6759 13.0116 32.2448 17.8967C33.8137 22.7819 35.3454 29.1171 33.9252 25.5034C32.505 21.8897 35.2748 11.8293 37.4237 14.0116C39.5726 16.194 36.5017 29.526 34.6837 27.4255C32.8657 25.3249 42.6583 16.4989 44.0079 19.198C45.3575 21.8971 37.1374 29.6822 36.6467 27.5481C36.1559 25.4141 43.8295 22.715 46.6475 26.6968C49.4656 30.6785 43.4725 28.1839 40.1042 28.6189C37.741 28.875 35.3654 28.9991 32.9884 28.9906L31.6016 28.0872Z",
    fill: "#707FE0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8732 28.7977C33.8732 28.7977 33.1148 25.3327 30.4863 24.5371C30.4863 24.5371 31.2671 32.9728 38.2937 28.6936C38.3234 28.675 36.84 27.3106 33.8732 28.7977Z",
    fill: "#191919"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.461 28.9756C33.461 28.9756 22.4489 53.8476 36.729 72.3809",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0742 25.3582C35.0742 25.3582 40.004 20.8188 44.6959 21.4582",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4267 20.8408C43.936 20.8408 43.527 21.1085 43.5159 21.4766C43.5047 21.8446 43.8876 22.1569 44.3784 22.1755C44.5833 22.2074 44.7927 22.1592 44.963 22.0408C45.1333 21.9224 45.2515 21.743 45.293 21.5398C45.3078 21.1903 44.9175 20.8594 44.4267 20.8408Z",
    fill: "#191919"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7539 25.8595C34.7539 25.8595 37.9066 19.9408 42.5613 19.0039",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.097 18.5095C41.6248 18.6545 41.3534 19.0597 41.4427 19.4092C41.5349 19.5942 41.6953 19.7363 41.8901 19.8057C42.0849 19.875 42.2989 19.8661 42.4874 19.7809C42.9595 19.636 43.2309 19.2344 43.1417 18.8812C43.0495 18.6962 42.8891 18.5541 42.6943 18.4847C42.4995 18.4154 42.2854 18.4243 42.097 18.5095Z",
    fill: "#191919"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7539 25.86C34.7539 25.86 35.6908 24.8376 39.2487 25.28",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1815 24.5735C38.7688 24.6219 38.4639 24.9156 38.5011 25.2316C38.5475 25.4021 38.6584 25.5479 38.8103 25.6381C38.9623 25.7283 39.1434 25.7558 39.3153 25.7149C39.728 25.6703 40.0329 25.3766 39.9957 25.0606C39.9485 24.8904 39.8376 24.7449 39.686 24.6542C39.5344 24.5635 39.3538 24.5346 39.1815 24.5735Z",
    fill: "#191919"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6658 23.7004C37.2532 23.7488 36.9483 24.0425 36.9855 24.3548C37.0327 24.5249 37.1436 24.6705 37.2952 24.7611C37.4467 24.8518 37.6274 24.8807 37.7997 24.8418C38.2124 24.7935 38.5172 24.4997 38.48 24.1837C38.4329 24.0137 38.3218 23.8685 38.1701 23.7785C38.0184 23.6884 37.8377 23.6604 37.6658 23.7004Z",
    fill: "#191919"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2028 21.2839C35.1468 21.4511 35.1587 21.6336 35.2359 21.7921C35.313 21.9506 35.4493 22.0725 35.6155 22.1316C35.924 22.1948 36.2438 21.9159 36.3293 21.5107C36.3834 21.343 36.3707 21.1608 36.2938 21.0022C36.217 20.8435 36.0818 20.7207 35.9166 20.6593C35.6043 20.5961 35.2846 20.875 35.2028 21.2839Z",
    fill: "#191919"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7533 25.8598C34.7533 25.8598 33.6379 20.7813 35.7645 17.3906",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1814 17.3685C35.1201 17.4362 35.0752 17.517 35.0502 17.6048C35.0251 17.6925 35.0206 17.7849 35.037 17.8747C35.0534 17.9645 35.0902 18.0493 35.1446 18.1226C35.199 18.1959 35.2696 18.2557 35.3508 18.2973C35.432 18.3389 35.5217 18.3613 35.613 18.3627C35.7043 18.3642 35.7946 18.3445 35.8771 18.3054C35.9596 18.2663 36.0319 18.2088 36.0886 18.1372C36.1452 18.0656 36.1847 17.982 36.2038 17.8927C36.2651 17.8251 36.31 17.7443 36.3351 17.6565C36.3601 17.5687 36.3646 17.4764 36.3482 17.3866C36.3319 17.2968 36.295 17.2119 36.2406 17.1387C36.1862 17.0654 36.1157 17.0056 36.0344 16.964C35.9532 16.9223 35.8635 16.8999 35.7722 16.8985C35.681 16.8971 35.5906 16.9167 35.5081 16.9558C35.4257 16.9949 35.3533 17.0525 35.2966 17.1241C35.24 17.1956 35.2006 17.2793 35.1814 17.3685Z",
    fill: "#191919"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M127.202 28.626C127.202 28.626 129.931 27.3545 125.157 23.8784C121.439 21.1793 124.911 17.2607 127.492 21.3912C130.124 25.6146 127.737 27.7598 128.529 24.3282C129.321 20.8967 126.741 18.6846 128.551 16.915C129.786 15.7067 133.912 17.4838 132.187 21.7481C130.54 25.8154 129.715 30.8009 129.957 27.4809C130.198 24.1609 136.031 17.3908 136.894 19.8706C137.756 22.3504 130.47 31.5445 129.83 29.2469C129.191 26.9493 140.128 23.7222 140.08 26.3098C139.987 30.8493 130.901 31.8865 131.306 30.0648C131.711 28.2431 138.645 28.9495 139.363 33.0874C140.08 37.2253 136.347 33.0874 133.589 32.1691C131.663 31.5013 129.775 30.7281 127.934 29.8529L127.202 28.626Z",
    fill: "#707FE0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M128.691 30.0016C128.691 30.0016 129.383 27.0273 127.657 25.4473C127.657 25.4473 125.155 32.2657 132.182 31.5445C132.182 31.5445 131.535 29.9421 128.691 30.0016Z",
    fill: "#191919"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M128.317 29.9902C128.317 29.9902 110.635 45.196 114.87 64.8037",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M97.667 21.7922C97.667 21.7922 96.8491 17.5353 99.9944 18.1636C106.742 19.5169 105.255 13.1223 99.775 15.0295C94.295 16.9367 97.47 20.6062 98.1318 16.5649C98.7935 12.5237 102.467 10.2447 101.381 8.55309C100.296 6.86149 97.7637 6.69419 96.4625 11.65C95.1612 16.6058 93.9939 23.0265 95.2096 19.3384C96.4253 15.6504 93.1016 5.76102 91.0865 8.05862C89.0715 10.3562 92.8674 23.4986 94.5701 21.3014C96.2729 19.1042 85.9969 10.8321 84.7997 13.6019C83.6026 16.3716 92.2353 23.6882 92.6071 21.5319C92.9789 19.3756 82.3534 20.0894 84.1826 24.6177C86.0415 29.2129 88.9154 22.5543 92.3023 22.7811C95.6892 23.0079 96.3398 22.7811 96.3398 22.7811L97.667 21.7922Z",
    fill: "#707FE0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4463 22.6254C95.4463 22.6254 96.0077 19.1233 98.573 18.1641C98.573 18.1641 98.2644 26.6332 90.9961 22.7481C90.9961 22.7481 92.4014 21.3056 95.4463 22.6254Z",
    fill: "#191919"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8551 22.7822C95.8551 22.7822 108.232 47.0037 95 66.3028",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6793 78.8168C22.6793 78.8168 15.0876 76.3147 15.4519 71.2139C15.8163 66.1131 14.1953 58.6924 14.1953 58.6924C14.1953 58.6924 27.3154 63.7672 22.6793 78.8168Z",
    fill: "#D5CD45"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5764 87.6839C34.5764 87.6839 19.8986 79.4341 18.668 70.582",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M22.202 66.1498C21.0644 66.3803 17.2648 67.4064 15.4357 67.3023C15.1866 65.5029 14.4839 60.0378 14.3203 59.2607L15.5918 59.3686C16.7518 60.0155 20.5402 62.5436 22.202 66.1498Z",
    fill: "#191919"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6215 53.4045C43.6215 53.4045 48.6628 42.6229 43.8222 38.3846C38.9817 34.1463 38.1637 27.2646 38.1637 27.2646C38.1637 27.2646 26.1739 44.0059 43.6215 53.4045Z",
    fill: "#D5CD45"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M41.268 70.0722C41.268 70.0722 47.131 49.6913 40.3906 40.6533",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2851 40.2848C74.2851 40.2848 75.8131 41.4559 73.6567 44.3298C73.6567 44.3298 71.928 40.1621 69.4668 39.9986C69.4668 39.9986 70.2401 38.5784 74.2851 40.2848Z",
    fill: "#191919"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9551 53.1638C52.9551 53.1638 53.3752 40.6943 59.0262 37.6048C64.6773 34.5153 74.2692 40.2965 74.2692 40.2965C74.2692 40.2965 63.0712 36.3333 52.9551 53.1638Z",
    fill: "#D5CD45"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7484 69.3622C51.7484 69.3622 50.477 48.193 59.0279 40.8467",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M174.312 79.9909C174.312 79.9909 175.208 81.3107 172.762 83.0023C172.762 83.0023 172.494 79.2845 170.605 78.5038C170.605 78.5038 171.583 77.5929 174.312 79.9909Z",
    fill: "#191919"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M154.189 84.5158C154.189 84.5158 157.785 74.831 163.034 73.8792C168.284 72.9275 174.314 79.9913 174.314 79.9913C174.314 79.9913 166.559 73.9499 154.189 84.5158Z",
    fill: "#D5CD45"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M148.994 96.9364C148.994 96.9364 153.545 79.9684 162.181 76.4365",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32125 91.8666C6.32125 91.8666 5.62602 93.3537 8.41065 94.6884C8.41065 94.6884 8.06118 90.833 9.86431 89.7288C9.87918 89.7288 8.72667 88.9555 6.32125 91.8666Z",
    fill: "#191919"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6791 93.1373C27.6791 93.1373 22.3849 83.8242 16.8528 83.7313C11.3207 83.6383 6.32031 91.8658 6.32031 91.8658C6.32031 91.8658 13.28 84.393 27.6791 93.1373Z",
    fill: "#D5CD45"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0666 104.974C35.0666 104.974 27.5826 88.3743 18.1543 86.2031",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4372 63.1234C25.4372 63.1234 22.2027 53.5836 15.7709 54.0966C9.33911 54.6097 0 52.6504 0 52.6504C0 52.6504 6.5396 69.1016 25.4372 63.1234Z",
    fill: "#D5CD45"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9438 50.8251C23.9438 50.8251 32.7438 41.0212 29.2156 35.6304C25.6874 30.2396 23.6761 15.8555 23.6761 15.8555C23.6761 15.8555 3.67437 35.8981 23.9438 50.8251Z",
    fill: "#D5CD45"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7387 78.0023C36.7387 78.0023 26.195 59.6029 15.0156 58.1455",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3395 67.7781C29.3395 67.7781 23.8595 61.8519 23.9413 50.825C23.9268 44.2465 23.2026 37.6887 21.7812 31.2656",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4322 19.7625C94.4322 19.7625 89.5024 15.2119 84.8105 15.8625",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0852 15.2421C85.2896 15.2101 85.4985 15.2579 85.6688 15.3755C85.839 15.4931 85.9575 15.6716 85.9998 15.8742C85.9998 16.246 85.628 16.5582 85.1336 16.5731C84.929 16.6061 84.7197 16.5587 84.5492 16.441C84.3788 16.3232 84.2605 16.1441 84.219 15.9411C84.2078 15.5767 84.5945 15.2645 85.0852 15.2421Z",
    fill: "#191919"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7605 20.2648C94.7605 20.2648 91.6078 14.3423 86.9531 13.4092",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4203 12.9155C87.8888 13.0605 88.1825 13.462 88.0709 13.8152C87.978 13.9996 87.8176 14.1412 87.6231 14.2104C87.4285 14.2796 87.2148 14.2713 87.0262 14.187C86.5578 14.042 86.2641 13.6368 86.3719 13.2873C86.4797 12.9378 86.9482 12.7705 87.4203 12.9155Z",
    fill: "#191919"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7585 20.2642C94.7585 20.2642 93.8216 19.2418 90.2637 19.6879",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3428 18.9782C90.7555 19.0265 91.0604 19.3202 91.0232 19.6362C90.9776 19.8065 90.8675 19.9522 90.7161 20.0425C90.5648 20.1327 90.3841 20.1604 90.2127 20.1195C89.8 20.0712 89.4952 19.7775 89.5324 19.4652C89.5771 19.2943 89.687 19.1476 89.8384 19.0566C89.9899 18.9656 90.1709 18.9375 90.3428 18.9782Z",
    fill: "#191919"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8485 18.1045C92.2612 18.1491 92.5661 18.4428 92.5289 18.7588C92.4825 18.9293 92.3716 19.0751 92.2196 19.1653C92.0677 19.2555 91.8866 19.2831 91.7147 19.2421C91.302 19.1975 90.9971 18.9038 91.0343 18.5878C91.0807 18.4173 91.1916 18.2715 91.3435 18.1813C91.4955 18.091 91.6766 18.0635 91.8485 18.1045Z",
    fill: "#191919"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9001 16.5326C94.2118 16.4681 94.3962 16.0865 94.3121 15.6804C94.228 15.2742 93.9072 14.9973 93.5955 15.0619C93.2839 15.1264 93.0994 15.508 93.1835 15.9141C93.2677 16.3202 93.5885 16.5972 93.9001 16.5326Z",
    fill: "#191919"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7593 20.265C94.7593 20.265 95.8746 15.1865 93.748 11.7959",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3337 11.7738C94.3954 11.8414 94.4406 11.9224 94.4658 12.0104C94.491 12.0984 94.4956 12.1911 94.4791 12.2811C94.4627 12.3712 94.4257 12.4563 94.371 12.5297C94.3163 12.6031 94.2454 12.6629 94.1638 12.7044C94.0823 12.746 93.9922 12.7681 93.9006 12.7691C93.8091 12.7702 93.7186 12.75 93.6361 12.7103C93.5536 12.6707 93.4813 12.6125 93.425 12.5403C93.3687 12.4681 93.3298 12.3839 93.3113 12.2942C93.2497 12.2266 93.2045 12.1456 93.1793 12.0576C93.1541 11.9696 93.1495 11.8769 93.1659 11.7869C93.1824 11.6968 93.2194 11.6117 93.2741 11.5383C93.3287 11.4649 93.3996 11.4051 93.4812 11.3636C93.5628 11.322 93.6529 11.2999 93.7444 11.2989C93.836 11.2978 93.9265 11.318 94.009 11.3576C94.0915 11.3973 94.1637 11.4555 94.22 11.5277C94.2764 11.5999 94.3153 11.6841 94.3337 11.7738Z",
    fill: "#191919"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M130.012 28.9609C130.012 28.9609 134.547 25.429 138.511 26.3212",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M138.328 25.7748C138.155 25.7312 137.972 25.7564 137.817 25.8452C137.663 25.934 137.549 26.0794 137.499 26.2507C137.462 26.563 137.771 26.8567 138.187 26.9088C138.36 26.9514 138.542 26.9258 138.697 26.8371C138.851 26.7485 138.966 26.6037 139.016 26.4329C139.046 26.1206 138.745 25.8232 138.328 25.7748Z",
    fill: "#191919"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M129.703 29.3701C129.703 29.3701 132.819 24.537 136.856 24.0723",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 23.6141C136.091 23.7033 135.812 24.0268 135.879 24.3353C135.945 24.5 136.072 24.6329 136.233 24.7064C136.394 24.7798 136.578 24.7881 136.745 24.7294C137.158 24.6402 137.437 24.3167 137.37 24.0082C137.303 23.8432 137.176 23.7102 137.014 23.6368C136.852 23.5634 136.668 23.5553 136.5 23.6141Z",
    fill: "#191919"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M129.703 29.3702C129.703 29.3702 130.577 28.5635 133.581 29.1992",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M133.578 28.5852C133.206 28.5852 132.938 28.8268 132.95 29.0982C132.976 29.2472 133.06 29.38 133.183 29.4682C133.305 29.5564 133.458 29.5931 133.608 29.5704C133.979 29.5704 134.247 29.3287 134.236 29.0573C134.209 28.9088 134.125 28.7766 134.002 28.6886C133.879 28.6005 133.727 28.5634 133.578 28.5852Z",
    fill: "#191919"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M132.355 27.7299C132.278 27.7217 132.201 27.7288 132.127 27.7508C132.053 27.7728 131.985 27.8092 131.925 27.858C131.865 27.9068 131.816 27.9669 131.78 28.0349C131.744 28.1029 131.722 28.1774 131.715 28.2541C131.685 28.39 131.698 28.5318 131.752 28.66C131.807 28.7881 131.899 28.8962 132.018 28.969C132.137 29.0419 132.275 29.076 132.414 29.0666C132.553 29.0572 132.685 29.0047 132.793 28.9165C132.9 28.8282 132.978 28.7086 133.014 28.5743C133.051 28.44 133.044 28.2977 132.996 28.1671C132.948 28.0366 132.86 27.9243 132.745 27.8459C132.63 27.7676 132.494 27.727 132.355 27.7299Z",
    fill: "#191919"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M130.414 25.4845C130.413 25.5794 130.437 25.6728 130.486 25.7542C130.535 25.8357 130.605 25.9019 130.689 25.9455C130.774 25.9891 130.868 26.0083 130.963 26.001C131.057 25.9937 131.148 25.9601 131.224 25.904C131.301 25.8479 131.36 25.7716 131.396 25.6836C131.431 25.5957 131.441 25.4995 131.425 25.4061C131.409 25.3126 131.367 25.2256 131.304 25.1547C131.241 25.0838 131.159 25.032 131.068 25.0049C130.919 24.9854 130.767 25.0243 130.645 25.1136C130.523 25.203 130.441 25.3358 130.414 25.4845Z",
    fill: "#191919"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M129.703 29.3695C129.703 29.3695 129.119 24.9527 131.19 22.209",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M130.672 22.1421C130.643 22.2336 130.641 22.3313 130.665 22.424C130.689 22.5167 130.739 22.6008 130.809 22.6664C130.879 22.732 130.966 22.7766 131.06 22.795C131.154 22.8134 131.251 22.8049 131.341 22.7705C131.43 22.7361 131.508 22.6771 131.566 22.6003C131.623 22.5236 131.658 22.4322 131.665 22.3367C131.673 22.2411 131.654 22.1453 131.61 22.0603C131.566 21.9752 131.498 21.9044 131.416 21.8559C131.278 21.8014 131.126 21.8006 130.988 21.8537C130.85 21.9067 130.737 22.0097 130.672 22.1421Z",
    fill: "#191919"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M100.425 37.5224C100.425 37.5224 98.0564 25.302 106.466 23.168C106.466 23.168 105.351 26.6032 103.719 28.3543C102.086 30.1054 100.187 35.9386 100.425 37.5224Z",
    fill: "#191919"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M114.1 57.2196C114.1 57.2196 116.063 46.7317 123.442 47.6797C123.442 47.6797 121.457 50.0629 119.617 50.9514C117.777 51.84 114.408 55.8849 114.1 57.2196Z",
    fill: "#191919"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M120.086 39.9097C120.086 39.9097 127.707 32.4406 122.811 26.8379C122.811 26.8379 121.937 29.8121 122.224 31.8383C122.51 33.8645 121.023 38.9096 120.086 39.9097Z",
    fill: "#191919"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3443 58.0895C30.3443 58.0895 26.9462 43.025 39.0365 40.3965C39.0365 40.3965 37.4156 44.6311 35.0919 46.7911C32.7683 48.9511 30.0023 56.1376 30.3443 58.0895Z",
    fill: "#191919"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M101.057 44.8696C101.057 44.8696 99.1716 32.5674 90.5352 33.389C90.5352 33.389 92.7658 36.2443 94.8701 37.3485C96.9744 38.4526 100.752 43.3007 101.057 44.8696Z",
    fill: "#191919"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2491 96.3426C54.743 93.9178 58.8866 85.9832 56.5042 78.6203C54.1218 71.2573 46.1154 67.2541 38.6216 69.6789C31.1277 72.1037 26.9841 80.0382 29.3665 87.4012C31.7489 94.7642 39.7553 98.7673 47.2491 96.3426Z",
    fill: "#707FE0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4425 116.983C50.2698 119.743 48.0648 121.935 45.2981 123.092C42.5315 124.248 39.4224 124.277 36.6345 123.173C35.2662 122.636 34.0192 121.83 32.9669 120.804C31.9146 119.777 31.0782 118.551 30.507 117.196C29.9357 115.842 29.6412 114.387 29.6406 112.917C29.6401 111.447 29.9336 109.992 30.5038 108.637C31.6766 105.876 33.882 103.683 36.6493 102.526C39.4166 101.368 42.5266 101.339 45.3155 102.443C46.6839 102.98 47.931 103.786 48.9832 104.813C50.0354 105.84 50.8716 107.067 51.4425 108.422C52.0134 109.777 52.3076 111.232 52.3075 112.703C52.3075 114.173 52.0134 115.628 51.4425 116.983Z",
    fill: "#707FE0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2568 132.504C95.0848 135.265 92.8801 137.458 90.1134 138.615C87.3467 139.772 84.2372 139.802 81.4488 138.698C80.0819 138.161 78.8362 137.356 77.7848 136.33C76.7334 135.304 75.8976 134.079 75.3265 132.726C74.7554 131.373 74.4604 129.919 74.459 128.45C74.4576 126.981 74.7497 125.527 75.3182 124.173C76.4902 121.412 78.6955 119.218 81.463 118.061C84.2306 116.903 87.341 116.874 90.1299 117.979C91.4968 118.516 92.7425 119.322 93.7937 120.347C94.845 121.373 95.6806 122.599 96.2514 123.952C96.8222 125.305 97.1168 126.759 97.1177 128.228C97.1186 129.696 96.8259 131.15 96.2568 132.504Z",
    fill: "#707FE0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M152.016 94.096C155.884 87.2893 152.949 78.3212 145.461 74.0654C137.972 69.8095 128.765 71.8773 124.897 78.6841C121.028 85.4908 123.963 94.4589 131.452 98.7148C138.941 102.971 148.147 100.903 152.016 94.096Z",
    fill: "#707FE0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M124.777 76.7494C119.999 82.9693 110.497 83.8988 103.552 78.8202C96.607 73.7417 94.8522 64.5885 99.6296 58.3724C104.407 52.1562 113.91 51.2268 120.854 56.3016C127.799 61.3763 129.554 70.5296 124.777 76.7494Z",
    fill: "#707FE0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4458 73.9972C103.119 73.7428 109.966 67.2391 109.738 59.4708C109.51 51.7024 102.294 45.6112 93.6207 45.8656C84.9472 46.1199 78.1007 52.6236 78.3286 60.392C78.5564 68.1603 85.7723 74.2516 94.4458 73.9972Z",
    fill: "#707FE0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6379 85.9059C31.6974 85.1289 37.4079 68.3319 53.1342 57.4648C72.8014 43.8763 99.5249 50.2448 108.7 53.5091C122.404 58.3868 136.212 65.2387 145.581 76.2917C155.671 88.1887 157.519 108.012 151.656 119.719C144.339 134.334 125.412 131.854 113.775 127.214C113.775 127.214 100.079 140.848 75.9541 135.516C65.6595 133.241 51.859 133.419 40.0067 123.136C24.6447 109.804 31.571 86.7908 31.6379 85.9059Z",
    fill: "#707FE0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M126.609 100.38C126.609 100.38 101.165 97.2571 113.764 127.215",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M114.029 102.774C114.029 102.774 107.445 90.8065 118.688 85.9287",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0254 79.1875C48.0254 79.1875 79.9984 79.0797 93.5126 101.212",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2418 58.0781C73.2418 58.0781 59.1142 72.7114 72.9741 84.4745",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9716 75.6455C46.9716 75.6455 49.0089 78.4041 46.9121 83.412",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9935 99.881C97.9935 99.881 93.6883 97.7767 92.3945 104.662",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2638 54.8438C73.2638 54.8438 71.5276 57.3272 75.3383 60.4204",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M118.672 82.5713C118.672 82.5713 116.936 85.0511 120.747 88.148",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M129.157 98.7471C129.157 98.7471 126.078 98.8549 125.777 103.692",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0586 90.1553C31.0586 90.1553 34.7578 104.681 56.1649 101.721",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1387 123.779C41.1387 123.779 52.6638 125.838 53.5673 114.112",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2793 112.96C49.2793 112.96 54.9861 116.013 55.7706 112.235",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1153 91.2412C84.1153 91.2412 58.2618 92.4272 69.3185 114.173",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0178 115.886C67.0178 115.886 66.646 113.403 71.7282 114.645",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7734 108.261C85.7734 108.261 102.288 107.443 103.883 127.947",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7227 119.341C85.7227 119.341 94.136 114.507 102.163 119.657",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4233 124.396C75.4233 124.396 69.103 132.788 77.706 135.628",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6875 122.341C73.6875 122.341 74.6281 124.858 76.9294 124.609",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3594 117.83C84.3594 117.83 86.0398 118.109 85.9469 121.176",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2305 106.012C84.2305 106.012 87.3274 109.585 84.7435 110.503",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M108.701 53.5092C108.701 53.5092 85.8808 50.8361 88.7026 70.2653",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M105.756 71.0347C105.756 71.0347 118.222 60.8107 140.655 72.0905",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M107.006 64.718C107.006 64.718 110.37 64.3053 112.542 67.6922",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M126.158 117.259C126.158 117.259 146.19 110.436 139.115 97.2939",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M151.657 119.712C151.657 119.712 151.285 111.574 139.529 107.67",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2383 82.3552C87.2383 82.3552 91.774 90.5901 109.352 81.0391",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M152.735 90.9282C152.735 90.9282 141.05 83.5446 137.842 90.2515",
    stroke: "#191919",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1805 71.5627C76.4852 75.6077 73.8493 78.3812 72.2878 77.7603C70.7263 77.1394 70.8379 73.3584 72.5332 69.3135C74.2285 65.2685 76.8644 62.4913 78.4222 63.1122C79.9799 63.733 79.8721 67.5178 78.1805 71.5627Z",
    fill: "#8497E0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7007 82.7904C91.8565 82.4409 88.8674 80.8311 89.0087 79.1953C89.15 77.5595 92.4068 76.5148 96.251 76.8642C100.095 77.2137 103.088 78.8235 102.943 80.4594C102.798 82.0952 99.545 83.1399 95.7007 82.7904Z",
    fill: "#8497E0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M119.933 112.749C118.242 116.794 115.602 119.568 114.044 118.947C112.486 118.326 112.594 114.545 114.29 110.5C115.985 106.455 118.621 103.678 120.179 104.299C121.736 104.92 121.628 108.704 119.933 112.749Z",
    fill: "#8497E0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M132.323 77.6379C127.089 76.214 123.215 73.7751 123.664 72.1951C124.114 70.615 128.728 70.4812 133.963 71.9051C139.197 73.329 143.075 75.7641 142.621 77.3479C142.168 78.9317 137.558 79.0581 132.323 77.6379Z",
    fill: "#8497E0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3011 102.346C74.0146 104.733 71.1593 105.759 69.9288 104.632C68.6982 103.506 69.557 100.665 71.8509 98.2784C74.1447 95.8916 76.9926 94.8692 78.2232 95.992C79.4538 97.1148 78.5912 99.9626 76.3011 102.346Z",
    fill: "#8497E0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2742 85.8803C42.3636 90.2004 42.8246 94.2751 41.304 94.9778C39.7834 95.6804 36.8426 92.7471 34.757 88.4196C32.6713 84.0921 32.2066 80.0248 33.7271 79.3221C35.2477 78.6195 38.1811 81.5379 40.2742 85.8803Z",
    fill: "#8497E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg1);
export default __webpack_public_path__ + "static/media/pg1.05273d78f6a2faace4fc090f5d7d8bf5.svg";
export { ForwardRef as ReactComponent };